let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5wWZN")).then(() => parcelRequire('athk0'));